/* *Developed by pmatute */
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import ElegantNavbar from './components/layout/ElegantNavbar';
import HomePage from './pages/HomePage';
import LandingPage from './pages/LandingPage';
import BookDetailPage from './pages/BookDetailPage';
import BooksPage from './pages/BooksPageSimple';
import MangaPage from './pages/MangaPageSimple';
import ComicsPage from './pages/ComicsPageSimple';
import CartPage from './pages/CartPage';
import { CartProvider } from './contexts/CartContext';
import { LanguageProvider } from './contexts/LanguageContext';
import './styles/globals.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const PageWithNavbar = ({ children }) => (
  <div className="page-with-navbar">
    <ElegantNavbar />
    <div className="page-with-navbar__content">{children}</div>
  </div>
);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <CartProvider>
          <BrowserRouter>
            <div className="min-h-screen">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/books" element={<PageWithNavbar><BooksPage /></PageWithNavbar>} />
                <Route path="/books/:id" element={<PageWithNavbar><BookDetailPage /></PageWithNavbar>} />
                <Route path="/libro/:id" element={<PageWithNavbar><BookDetailPage /></PageWithNavbar>} />
                <Route path="/manga" element={<PageWithNavbar><MangaPage /></PageWithNavbar>} />
                <Route path="/comics" element={<PageWithNavbar><ComicsPage /></PageWithNavbar>} />
                <Route path="/cart" element={<PageWithNavbar><CartPage /></PageWithNavbar>} />
              </Routes>
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                  success: {
                    duration: 3000,
                    iconTheme: {
                      primary: '#10b981',
                      secondary: '#fff',
                    },
                  },
                  error: {
                    duration: 5000,
                    iconTheme: {
                      primary: '#ef4444',
                      secondary: '#fff',
                    },
                  },
                }}
              />
            </div>
          </BrowserRouter>
        </CartProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App;
